const DEFAULT_TITLE = 'Description';

export function buildProductDescriptionSections(options: { text: string, keyFeatures?: string, descriptionCutoffLength: number }) {
    const { text, keyFeatures, descriptionCutoffLength } = options;
    const sectionRe = /<h1[^>]*>([^<]*)<\/h1>/g;
    const matches = text.split(sectionRe);
    let result: Array<{ title: string; content: string; extendedContent?: string }> = [];
    if (matches.length === 1) {
        result = [
            {
                title: DEFAULT_TITLE,
                content: text,
            },
        ];
    } else {
        matches.unshift(DEFAULT_TITLE);
        result = pairwise(matches).map(([title, content]) => ({ title, content }));
    }
    if (keyFeatures && keyFeatures.trim() !== '' && keyFeatures.trim() !== '<p></p>') {
        result.unshift({
            title: 'Key features',
            content: keyFeatures,
        });
    } else {
        if (descriptionCutoffLength < result[0].content.length) {
            let preview = '';
            let content = result[0].content;
            while (preview.length < descriptionCutoffLength) {
                const paragEndIndex = content.indexOf(`</p>`);
                const closingIndex = -1 < paragEndIndex ? paragEndIndex + 4 : content.length - 1;
                const parag = content.substring(0, closingIndex).trim();
                preview += parag;
                content = content.substring(closingIndex);
            }
            result[0].extendedContent = result[0].content;
            result[0].content = preview;
        }
    }
    return result;
}

function pairwise<T>(arr: T[]): T[][] {
    const result: T[][] = [];
    for (let i = 0; i < arr.length; i += 2) {
        result.push([arr[i], arr[i + 1]]);
    }
    return result;
}
